import React from "react";
import styled, { useTheme } from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { getBoxShadow } from "@utils/product/productValidators";
import { StockItemRequestClass } from "@src/types/HistoryRequest";
import { useTranslation } from "react-i18next";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";

type ActionCardProps = {
  stockItemRequest: StockItemRequestClass;
  skipUnread?: boolean;
};

const ActionCard = ({ stockItemRequest, skipUnread }: ActionCardProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();

  return (
    <>
      <CardContainer>
        <StatusBottomContainer>
          <StoreAttributeContainer>
            <LeftText isMobile={theme.isMobile}>
              <VDBIcon
                variant={IconsVariant.VDBCustom}
                name={VDBIcons.WARNING}
                color={theme["core-01"]}
                size={24}
              />
            </LeftText>

            <RightText>
              <VDBText
                type={typography["H3-M"]}
                isBold={true}
                color={theme["core-05"]}
              >
                {stockItemRequest?.status === "decline"
                  ? t("requestHistoryDetail.quote.declinedReason.text")
                  : t("requestHistoryDetail.quote.withdrawReason.text")}
              </VDBText>
            </RightText>
          </StoreAttributeContainer>
          <Divider />

          <BottomText>
            <VDBText
              type={typography["BODY-R"]}
              isBold={true}
              color={theme["core-06"]}
            >
              {skipUnread
                ? stockItemRequest?.notes
                : stockItemRequest?.children?.[0]?.notes}
            </VDBText>
          </BottomText>
        </StatusBottomContainer>
      </CardContainer>
      <Spacer size={SpaceType.Double} />
    </>
  );
};

export default ActionCard;

const CardContainer = styled.View`
  background-color: ${({ theme }) => theme["error-02"]};
  border-radius: 8px;
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
`;

const StatusBottomContainer = styled.View`
  padding-top: ${SpaceType.Extra}px;
  padding-bottom: ${SpaceType.Extra}px;
  gap: ${SpaceType.Basic}px;
`;

const StoreAttributeContainer = styled.View`
  padding: ${SpaceType.ExtraSmall}px ${SpaceType.Double}px;
  flex-direction: row;
`;

const LeftText = styled.View<{
  isMobile?: boolean;
}>`
  background-color: ${({ theme }) => theme["error-01"]};
  padding: ${({ isMobile }) =>
    isMobile ? `${SpaceType.ExtraSmall}px` : `${SpaceType.Basic}px`};
  border-radius: ${SpaceType.large}px;
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["error-01"]};
  width: 100%;
`;

const RightText = styled.View`
  align-self: center;
  padding-left: ${SpaceType.Double}px;
`;

const BottomText = styled.View`
  padding: ${SpaceType.Double}px;
`;
